export const SkillsData = [
  {
    type: "Programming & Development",
    list: [
      {
        name: "C",
        icon: <i class="devicon-c-plain colored"></i>
      },
      {
        name: "Java",
        icon: <i class="devicon-java-plain colored"></i>
      },
      {
        name: "Python",
        icon: <i class="devicon-python-plain colored"></i>
      },
      {
        name: "ReactJS",
        icon: <i class="devicon-react-original colored"></i>
        },
      {
        name: "HTML5",
        icon: <i class="devicon-html5-plain colored"></i>
        },
        {
          name: "CSS3",
          icon: <i class="devicon-css3-plain colored"></i>
          },
      {
        name: "JavaScript",
        icon: <i class="devicon-javascript-plain colored"></i>
      },
      {
        name: "Tailwind",
        icon: <i class="devicon-tailwindcss-plain colored"></i>
      },
      {
        name: "NodeJS",
        icon: <i class="devicon-nodejs-plain colored"></i>
      },
      {
        name: "MongoDB",
        icon: <i class="devicon-mongodb-plain colored"></i>
      },
      {
        name: "BootStrap",
        icon: <i class="devicon-bootstrap-plain colored"></i>
      },
      {
        name: "SaSS",
        icon: <i class="devicon-sass-original colored"></i>
      },
    ],
  },
  {
    type: "Tools",
    list: [
      {
        name: "AWS",
        icon: <i class="devicon-amazonwebservices-plain-wordmark colored"></i>
      
      },
      {
        name: "GitHub",
        icon: <i class="devicon-github-plain colored"></i>
      },
      {
        name: "Git",
        icon: <i class="devicon-git-plain colored"></i>
      },
      {
        name: "Docker",
        icon: <i class="devicon-docker-plain-wordmark colored"></i>
      
      },
      {
        name: "VScode",
        icon: <i class="devicon-vscode-plain colored"></i>
      },
      {
        name: "IntelliJ",
        icon: 
        <i class="devicon-intellij-plain-wordmark colored"></i>
      
      }
    ],
  },
];